import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'furtherCreditToABANumber',
    label: 'ABA Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'furtherCreditToAccountNumber',
    label: 'Account Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'furtherCreditToContact',
    label: 'Contact',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const furtherCreditToForm = {
  name: FormNames.FUNDING_INFORMATION,
  label: 'Further Credit To',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
